import { ActionCardModel } from '../../actionCard'

export class NodeSettings {
  public observer?: any | null = null
  public actionCardModel?: ActionCardModel
}
